import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRocketPromoTrialEndMobile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 72,
	viewBox: "0 0 72 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 36,
			cy: 36,
			r: 36,
			fill: "#003F66"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.11483 37.0539C8.68783 37.82 7.75067 38.0321 6.92817 37.5487C6.10568 37.0653 5.80917 36.1283 6.23617 35.3621C6.66317 34.596 7.60017 34.384 8.42266 34.8673C9.24516 35.3507 9.54182 36.2878 9.11483 37.0539Z",
			fill: "#03A9F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6694 27.4733C13.0085 27.4501 12.5406 26.876 12.5134 26.3173C12.4862 25.7587 13.0098 25.2193 13.5606 25.2386C14.2215 25.2618 14.6893 25.8359 14.7165 26.3946C14.7437 26.9532 14.3303 27.4964 13.6694 27.4733Z",
			fill: "#03A9F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.1797 33.1322C64.5926 34.1856 63.1869 34.5036 62.056 33.839C60.9251 33.1744 60.4801 31.7687 61.0673 30.7153C61.6544 29.6619 63.0601 29.3438 64.191 30.0084C65.3219 30.6731 65.7669 32.0788 65.1797 33.1322Z",
			fill: "#008DE6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.9156 47.854C61.4886 48.6201 60.5515 48.8321 59.729 48.3488C58.9065 47.8654 58.61 46.9283 59.037 46.1622C59.464 45.3961 60.401 45.184 61.2234 45.6674C62.0459 46.1508 62.3426 47.0879 61.9156 47.854Z",
			fill: "#03A9F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4968 47.8806C16.978 47.7908 18.4125 48.317 19.536 49.2414L28.2927 56.447C29.4162 57.3715 30.2287 58.6944 30.4658 60.1981C30.6299 61.2391 30.5 62.2396 30.115 63.0803C33.0523 62.3768 35.7537 60.7242 37.7874 58.1195C42.5964 51.9602 41.6058 42.941 35.5587 37.9651C29.5116 32.9892 20.7212 33.9598 15.9122 40.1192C13.9025 42.6932 12.8954 45.7904 12.866 48.8867C13.5815 48.3178 14.4713 47.9428 15.4968 47.8806Z",
			fill: "#9C27B0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3087 54.9981C26.4234 58.3653 35.8707 53.3039 43.4099 43.6933C50.949 34.0826 53.7251 23.562 49.6105 20.1949C45.4958 16.8277 36.0484 21.889 28.5093 31.4997C20.9701 41.1103 18.194 51.6309 22.3087 54.9981Z",
			fill: "#F5EEF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.082 50.3709C20.077 52.5359 20.6516 54.2359 21.9156 55.2645C23.1796 56.2931 24.9384 56.492 27.0177 56.0149L20.082 50.3709Z",
			fill: "#6C0685"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0387 56.3336C23.1813 54.5625 25.1919 52.5274 26.9856 50.2641C28.7792 48.0008 30.3052 45.5731 31.5478 43.0726C29.4052 44.8437 27.3945 46.8788 25.6009 49.1421C23.8073 51.4054 22.2812 53.8332 21.0387 56.3336Z",
			fill: "#9C27B0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.1025 20.5486L51.1126 28.7284C52.1029 24.7505 51.7793 21.4942 49.8293 19.9007C47.8793 18.3073 44.6842 18.6384 41.1025 20.5486Z",
			fill: "#9C27B0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.8215 34.4505C42.5155 36.1193 40.0233 36.2571 38.2741 34.8225C36.5249 33.3879 36.1369 30.8372 37.4187 29.1993C38.7005 27.5615 41.2168 27.3927 42.966 28.8273C44.7153 30.2619 45.1275 32.7818 43.8215 34.4505Z",
			fill: "#6C0685"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.6341 33.4774C41.8118 34.5281 40.2105 34.6355 39.0883 33.7152C37.9662 32.7949 37.7192 31.1716 38.5415 30.1209C39.3638 29.0702 40.9652 28.9629 42.0873 29.8832C43.2424 30.8306 43.4564 32.4267 42.6341 33.4774Z",
			fill: "#EEA0FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.9515 16.626C53.0007 16.5632 52.9827 16.4454 52.9155 16.3904C52.8483 16.3353 52.7319 16.3431 52.6827 16.4059L49.212 19.2856L50.9927 20.7439L52.9515 16.626Z",
			fill: "#C44FD8"
		})
	]
});
export default SvgRocketPromoTrialEndMobile;
